<template>
  <div class="py-2 is-flex">
    <up-label :label="label" :labelIcon="labelIcon"></up-label>
    <input
      class="px-2"
      type="text"
      v-model="label_input"
      :style="`width: ${sizeOfInputField}rem;font-size:${font_size}px;height:${font_size+15}px`"
      ref="colorinput"
      @focus="randomColor()"
      @blur="defaultColor()"
    />
  </div>
</template>

<script>
import UpLabel from "../Label";
import { addRandomBorderColor } from "./RandomColor.js";
export default {
  name: "up-textinput",
  components: {
    UpLabel,
  },
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
    },
    labelIcon: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "sm",
    },
    font_size : {
      type : Number,
      default : 13
    }
  },
  data() {
    return {
      label_input: this.value,
      randColor: addRandomBorderColor,
    };
  },
  methods: {
    randomColor() {
      let color = this.randColor();

      let input_element = this.$refs.colorinput;
      input_element.style.border = `2px solid ${color}`;
    },
    defaultColor() {
      let input_element = this.$refs.colorinput;
      input_element.style.border = "2px solid black";
    },
  },
  computed: {
    sizeOfInputField() {
      let sizes = { xxs : 2, xs: 4, sm: 6, md: 8, lg: 10, xl: 12 };
      if (sizes[this.size]) {
        return sizes[this.size];
      } else {
        return 5;
      }
    },
  },
  watch: {
    label_input: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
    },
    value: {
      handler: function(new_val) {
        this.label_input = new_val;
      },
    },
  },
};
</script>

<style scoped>
input {
  border: 2px solid black;
}
input:focus,
input:hover {
  outline: 0;
}
</style>
